module.exports = __webpack_public_path__ + "img/cerrar_azul.50b3b846.svg";